<template>
  <div>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"

    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="小区名称" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="小区名称"
              maxlength="30"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属租户" prop="tenantId">
            <el-select
              v-model="searchForm.tenantId"
              style="width: 100%"
              placeholder="所属租户"
              clearable
            >
              <el-option
                v-for="item in tenantList"
                :key="item.tenantId"
                :label="item.tenantName"
                :value="item.tenantId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属代理商" prop="agentId">
            <el-select
              v-model="searchForm.agentId"
              style="width: 100%"
              placeholder="所属代理商"
            >
              <el-option
                v-for="item in agentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="所属小区" prop="areaId">
            <el-select
              v-model="searchForm.areaId"
              style="width: 100%"
              placeholder="所属小区"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="6">
          <el-form-item label="所属充电站" prop="stationId">
            <el-select
              v-model="searchForm.stationId"
              style="width: 100%"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in stationList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchRecord"
              size="small"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small">
              清空
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          ref="crud"
          @on-load="onLoad"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
          @selection-change="selectionChange"
        >
          
        <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="mulitAdd">
          批量添加</el-button
        >
       
      </template>
          
        </avue-crud>
  </div>
</template>
<script>
import {
  tenantGetList,
  agentGetList,
  propertyGetList,
  areaGetList,
  stationGetList,
  stationPage,
  updateEmphasisStation
} from "./api/index";
export default {
  data() {
    return {
      searchForm: {
        name: "",
        tenantId: "",
        agentId: "",
        areaId: "",
        stationId: "",
      },
      tenantList:[],
      agentList:[],
      areaList:[],
      selectionList :[],
     recordIds:[] ,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data:[],
      loading: false,
      option: {
        selection: true,
        index: true,
        indexLabel: "#",
        page: true,
        height: "auto",
        calcHeight: "auto",
        align: "left",
        menu: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
                    {
                        label: "小区名称",
                        prop: "name",
                        maxlength: 20,
                       
                        width: 150,
                        slot: true,
                        showWordLimit: true,
                        rules: [{
                                required: true,
                                message: "请输入小区名称",
                                trigger: "change"
                            }]
                    },
                    {
                        label: "所属物业",
                        prop: "propertyId",
                      
                        type: "select",
                        dicUrl: "/api/v4ward/saas/charger/property/getList",
                        props: {
                            label: "name",
                            value: "id"
                        },
                        rules: [{
                                required: true,
                                message: "请选择所属物业",
                                trigger: "change"
                            }]
                    },
                     {
                        label: "所属代理商",
                        prop: "agentName",
                       
                    },
                    {
                        label: "所属租户",
                        prop: "tenantId",
                       
                        type: "select",
                        dicUrl: "/api/charger-system/tenant/getList",
                        props: {
                            label: "tenantName",
                            value: "tenantId"
                        },
                        rules: [{
                                required: true,
                                message: "请选择所属租户",
                                trigger: "change"
                            }]
                    },
                   {
                        label: "负责人",
                        prop: "contact",
                       
                        maxlength: 20,
                        showWordLimit: true,
                    },
                    {
                        label: "负责人电话",
                        prop: "contactPhone",
                       
                        // search:true,
                        maxlength: 20,
                        showWordLimit: true,
                    },
                    {
                        label: "小区电价",
                        prop: "electricityPrice",
                        formslot: true,
                        hide: true,
                        rules: [{
                                required: true,
                                message: "请输入小区电价",
                                trigger: "change"
                            }]
                    },
                    
                    {
                        label: "地址",
                        prop: "address",
                        maxlength: 100,
                        
                        span: 24,
                        row: true,
                        width: 150,
                        slot: true,
                        showWordLimit: true,
                        rules: [{
                                required: true,
                                message: "请输入地址",
                                trigger: "change"
                            }]
                    },
                   
                    {
                        label: "备注",
                        prop: "description",
                         hide: true,
                        type: "textarea",
                        row: true,
                        width: 150,
                        slot: true,
                        span: 24,
                        maxlength: 200,
                        showWordLimit: true,
                    },
                ]
      },
    };
  },
  watch: {
    "searchForm.tenantId"(value) {
      this.searchForm.agentId = "";
      if (value == "") {
      } else {
        //获取代理商
        this.agentGetList(value);
      }
    },
    "searchForm.agentId"(value) {
      this.searchForm.areaId = "";
      if (value == "") {
      } else {
        //获取小区
        this.areaGetList(value);
      }
    },

    "searchForm.areaId"(value) {
      this.searchForm.stationId = "";
      if (value == "") {
      } else {
        //获取小区
        this.stationGetList(value);
      }
    },
  },
  created(){
    this.tenantGetList()
  },
  methods:{
    searchRecord(){
      this.page.currentPage = 1;

      this.onLoad();
    },
    searchClear(){
      this.tool.clearObject(this.searchForm);
    },
    mulitAdd(){
        if (this.recordIds.length == 0 ) {
        this.$message({
          message: "请选择需要添加的数据！",
          type: "warning",
        });
        return;
      }else{
        updateEmphasisStation({idList:this.recordIds}).then(res=>{
            this.$message.success('添加成功！')
            this.$emit('success')
        })
      }
    },
    selectionChange(val) {
      this.selectionList = val;
      this.recordIds = [];
      val.forEach((element) => {
        this.recordIds.push(element.id);
      });
      console.log(this.recordIds);
    },
      //获取租户下拉框
      tenantGetList() {
      tenantGetList().then((res) => {
        this.tenantList = res.data;
      });
    },
    //获取代理商
    agentGetList(value) {
      agentGetList({ tenantId: value }).then((res) => {
        this.agentList = res.data;
      });
    },

    //获取小区
    areaGetList(value) {
      areaGetList({ agentId: value }).then((res) => {
        this.areaList = res.data;
      });
    },
    onLoad() {
          this.loading = true;
          stationPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
    
  }
};
</script>
